/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../services/search/solr_search_collection.ts"/>

module DealerwareWebComponents {
    "use strict";

    import DealerwareSolrSearchSmartFilter = DealerwareWebServices.DealerwareSolrSearchSmartFilter;

    export class EmployeeSearchDirectiveController {
        public static $inject : string[] = [
            '$dealerwareSolrSearchEmployeeCollection',
            '$timeout',
            '$state',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$q',
            '$filter',
            '$rootScope',
            '$mobilityCompanyAuthentication',
            '$controller'
        ];

        public location: any;
        public exportFilePrefix: string;
        public exportCols: any;
        public columns: any;
        public onEmployeeSelected: any;
        public modal: any;
        public showAddButton: boolean;
        public searchInProgress: boolean;
        public showInactiveAccounts: boolean;

        public collectionListName: string = 'EmployeeCollectionList';
        public landingPageController: any;
        public loader: any;

        constructor(public $dealerwareSolrSearchEmployeeCollection: any,
                    public $timeout: any,
                    public $state: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public $q: any,
                    public $filter: any,
                    public $rootScope: any,
                    public $auth: any,
                    public $controller: any) {
            this.initEmployeeColumns();
            this.$rootScope.$on('$authCompanyChanged', (args: any) => {
                this.clear();
            });

            this.location = this.$auth.location;
            this.exportFilePrefix = this.$filter('spaceless')(this.location.name.toLowerCase()) + '_employees';
            $dealerwareSolrSearchEmployeeCollection.locationId = this.location.id;

            // Load Employee search with 'all' employees.
            //
            this.$dealerwareSolrSearchEmployeeCollection.searchArgs.searchText = 'all';
            this.searchEmployees(undefined,undefined);
            this.$dealerwareSolrSearchEmployeeCollection.searchArgs.searchText = '';

            // Search field contents and results will persist from a previous incarnation of
            // this component so we need to clear it as we start loading it.
            //
            this.clear();

            this.landingPageController = this.$controller('LandingPageController');
        }

        public initEmployeeColumns(sortBy?: string, sortDirection?: string) : void {
            var _self = this;

            this.columns = [{
                key     :   'id',
                hidden  :   true
            },{
                key: 'user_profile_attributes.full_name',
                header: 'Full Name',
                onClick: function(e: any, employee: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.employees.details',
                        { employeeId: employee.data.id }
                    ));
                }
            },{
                key: 'email',
                header: 'Email',
                sortable: true,
                onClick: function(e: any, employee: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.employees.details',
                        { employeeId: employee.data.id }
                    ));
                }
            },{
                key: 'user_profile_attributes.phone_number',
                header: 'Phone Number',
                onClick: function(e: any, employee: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.employees.details',
                        { employeeId: employee.data.id }
                    ));
                }
            }];

            if (sortBy) {
                $.grep(this.columns, function(c: any) { return c.sortBy === sortBy || c.key === sortBy; })[0].sortDirection = sortDirection;
            }

            this.exportCols = [
                { header: 'Full Name', dataKey: 'user_profile_attributes.full_name' },
                { header: 'Email', dataKey: 'email' },
                { header: 'Phone Number', dataKey: 'user_profile_attributes.phone_number' }
            ];
        }

        public pageTransitionError(response : any) : void {
            this.loader.close();
            this.$dealerwareNotification.apiError(response);
        }

        public employeeSelected(record : any) : void {
            if (record instanceof DealerwareSolrSearchSmartFilter) {
                this.$dealerwareSolrSearchEmployeeCollection.searchArgs.searchText = record.name;
                this.searchEmployees(undefined,undefined);
            }
            else if (record) {
                if (this.onEmployeeSelected && angular.isFunction(this.onEmployeeSelected)) {
                    this.onEmployeeSelected({record: record});
                }
            }

        }

        public searchTextChanged(val : string) {
        }

        private _acq : any;

        public get autoCompletePromise() : any {
            return this._acq;
        }

        public set autoCompletePromise(acq : any) {
            this._acq = acq;
        }

        public cancelActiveAutoCompletePromise() {
            if (this._acq) {
                this._acq.resolve([]);
            }
            this._acq = undefined;
        }

        public newAutoCompletePromise() {
            this.cancelActiveAutoCompletePromise();
            this._acq = this.$q.defer();
            return this._acq;
        }

        public blurAutoComplete() {
            if ($('#employeeSearchAutoComplete').find('input').length) {
                $('#employeeSearchAutoComplete').find('input')[0].blur();
            }
        }

        public autoCompleteSearch() {
            var _self =this;
            var _deferred = this.newAutoCompletePromise();;

            if (this.searchInProgress) {
                this.$timeout(function() {
                    _self.cancelActiveAutoCompletePromise();
                },1);
            } else {
                this.$dealerwareSolrSearchEmployeeCollection.searchArgs.locationId = this.location.id;

                if (!this.showInactiveAccounts) {
                    this.$dealerwareSolrSearchEmployeeCollection.searchArgs.include_inactive = undefined;
                }
                else {
                    this.$dealerwareSolrSearchEmployeeCollection.searchArgs.include_inactive = true;
                }

                this.$dealerwareSolrSearchEmployeeCollection.autoCompleteSearch().then(
                    function(returnValue : any) {
                        _deferred.resolve(returnValue.data);
                        _self.autoCompletePromise = undefined;
                    },
                    function(response : any) {
                        _deferred.reject([]);
                        _self.autoCompletePromise = undefined;
                    }
                );
            }

            return _deferred.promise;
        }

        public searchEmployees(sortBy : string,sortDirection : string) : void {
            var _self = this;

            this.cancelActiveAutoCompletePromise();
            this.initEmployeeColumns(sortBy, sortDirection);
            this.blurAutoComplete();

            if (!sortBy) {
                this.searchInProgress = true;
                sortBy = "created_at";
                sortDirection = "desc";
            } else {
                this.loader = this.$dealerwareLoading.show('Loading...');
            }

            _self.$dealerwareSolrSearchEmployeeCollection.searchArgs.sortBy = sortBy;
            _self.$dealerwareSolrSearchEmployeeCollection.searchArgs.sortDirection = sortDirection;
            _self.$dealerwareSolrSearchEmployeeCollection.searchArgs.locationId = this.location.id;

            if (!this.showInactiveAccounts) {
                this.$dealerwareSolrSearchEmployeeCollection.searchArgs.include_inactive = undefined;
            }
            else {
                this.$dealerwareSolrSearchEmployeeCollection.searchArgs.include_inactive = true;
            }

            this.$dealerwareSolrSearchEmployeeCollection.search().then(
                function() {
                    _self.searchInProgress  =   false;
                    if (_self.loader) { _self.loader.close(); }
                    _self.$dealerwareSolrSearchEmployeeCollection.searchResults.subject = 'employee';
                    if (_self.$dealerwareSolrSearchEmployeeCollection.searchResults.recordTotal !== 1) {
                        _self.$dealerwareSolrSearchEmployeeCollection.searchResults.subject += 's';
                    }
                    _self.blurAutoComplete();
                },
                function(response : any) {
                    _self.searchInProgress = false;
                    if (_self.loader) { _self.loader.close(); }
                }
            );
        }

        public clear() : void {
            var collection = this.$dealerwareSolrSearchEmployeeCollection

            collection.searchArgs.clear();
            if (collection.searchResults) { collection.searchResults.clear(); }
        }

        public openCreateEmployee() : void {
            this.$dealerwareSolrSearchEmployeeCollection.searchArgs.searchText = '';
            this.modal.show();
        }

        public onCreateEmployeeSuccess(employee : any) : void {
            this.employeeSelected(employee);
        }
    }

    getDealerwareWebComponentsModule().controller('EmployeeSearchDirectiveController',EmployeeSearchDirectiveController);

    export class EmployeeSearchDirective implements ng.IDirective {

        public restrict         : string    =   'E';
        public controller       : any       =   'EmployeeSearchDirectiveController';
        public controllerAs     : string    =   'employeeSearchController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            onEmployeeSelected: '&',
            showAddButton: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/employee/search/employee_search_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareEmployeeSearch",() => new EmployeeSearchDirective());
}
